var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18280_5242",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18280_5242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 19.0003V17.354C4 16.9412 4.12017 16.555 4.3605 16.1955C4.601 15.8359 4.92442 15.5567 5.33075 15.358C6.27442 14.9054 7.21867 14.5659 8.1635 14.3398C9.10833 14.1134 10.0538 14.0003 11 14.0003C11.3687 14.0003 11.7373 14.0192 12.1058 14.057C12.4744 14.0949 12.843 14.1516 13.2115 14.2273C13.2218 14.9759 13.3937 15.6769 13.727 16.33C14.0603 16.9832 14.518 17.5399 15.1 18.0003V19.0003H4ZM18.6923 21.385L17.5253 20.228V16.6413C16.9546 16.4743 16.4904 16.1539 16.1328 15.68C15.7751 15.2064 15.5962 14.6657 15.5962 14.058C15.5962 13.309 15.8609 12.6699 16.3903 12.1405C16.9196 11.6112 17.5587 11.3465 18.3075 11.3465C19.0563 11.3465 19.6923 11.6114 20.2155 12.1413C20.7385 12.6711 21 13.3109 21 14.0605C21 14.6422 20.8388 15.1542 20.5163 15.5965C20.1939 16.0387 19.7783 16.3592 19.2693 16.558L20.2307 17.5195L19.077 18.679L20.2307 19.8388L18.6923 21.385ZM11 11.7695C10.175 11.7695 9.46875 11.4758 8.88125 10.8883C8.29375 10.3008 8 9.59453 8 8.76953C8 7.94453 8.29375 7.23828 8.88125 6.65078C9.46875 6.06328 10.175 5.76953 11 5.76953C11.825 5.76953 12.5313 6.06328 13.1188 6.65078C13.7063 7.23828 14 7.94453 14 8.76953C14 9.59453 13.7063 10.3008 13.1188 10.8883C12.5313 11.4758 11.825 11.7695 11 11.7695ZM18.3077 14.4425C18.5141 14.4425 18.6938 14.3628 18.847 14.2033C19.0003 14.0436 19.077 13.8605 19.077 13.654C19.077 13.4477 19.0003 13.2679 18.847 13.1148C18.6938 12.9614 18.5141 12.8848 18.3077 12.8848C18.1012 12.8848 17.9183 12.9614 17.7587 13.1148C17.5991 13.2679 17.5193 13.4477 17.5193 13.654C17.5193 13.8605 17.5991 14.0436 17.7587 14.2033C17.9183 14.3628 18.1012 14.4425 18.3077 14.4425Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingIn);
export default __webpack_public_path__ + "static/media/sing-in.3b728fc32e6106370cd366b00333fe0d.svg";
export { ForwardRef as ReactComponent };